import React from 'react';

interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  icon?: string;
  /** When true, card height is auto instead of 100%. Default false. */
  heightAuto?: boolean;
}

const Card: React.FC<CardProps> = ({ title, children, className = '', icon, heightAuto }) => {
  return (
    <div className={`card ${heightAuto ? 'h-auto' : 'h-100'} shadow-sm ${className}`}>
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          {icon && (
            <div className="me-3">
              <i className={`${icon} text-primary fs-3`}></i>
            </div>
          )}
          <h5 className="card-title mb-0">{title}</h5>
        </div>
        <div className="card-text">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Card;
